import {Component, OnInit, ViewChild} from '@angular/core';
import {FirmService} from '../services/firm.service';
import {SwalComponent} from '@sweetalert2/ngx-sweetalert2';
import Swal from 'sweetalert2';
import {NgxSpinnerService} from 'ngx-spinner';

declare var $: any;

@Component({
    selector: 'app-firm-payment',
    templateUrl: './firm-payment.component.html',
    styleUrls: ['./firm-payment.component.scss']
})
export class FirmPaymentComponent implements OnInit {


    @ViewChild('errorSwal') private errorSwal: SwalComponent;
    @ViewChild('successSwal') private successSwal: SwalComponent;
    @ViewChild('infoSwal') private infoSwal: SwalComponent;
    @ViewChild('confirmSwal') private confirmSwal: SwalComponent;

    paymentMethodList: any[] = [];
    paymentMethod: any;
    selectedFirm: any;
    paymentInfo: any = {};
    errorMessage = '';

    firmList: any[] = [];
    loading = false;

    constructor(
        private firmService: FirmService,
        private spinner: NgxSpinnerService) {
    }

    ngOnInit() {
        this.getPaymentMethodList();
    }

    getPaymentMethodList() {
        this.firmService.getFirmPaymentMethod().subscribe(res => {
            console.log(res);
            this.paymentMethodList = res;
        });
    }

    getFirmList(methodName: string) {
        this.spinner.show();

        this.firmService.getAllFirmIfHaveStorageCard(methodName)
            .subscribe(res => {
                this.firmList = res.result;
                this.selectedFirm = this.firmList[0];
                this.paymentInfo['phoneNumber'] = this.selectedFirm ? this.selectedFirm.phone : '';
                this.spinner.hide();
            }, error => {
                this.errorSwal.title = 'Firmalar Yüklenemedi yüklenemedi!';
                this.paymentInfo = {};
                this.errorSwal.show();
                this.spinner.hide();
            });
    }

    payment() {
        const paymentData = {
            KS_GUID: this.selectedFirm.paramStorageCardId,
            KK_Sahibi_GSM: this.paymentInfo.phoneNumber,
            Toplam_Tutar: this.paymentInfo.total,
            firmId: this.selectedFirm._id
        };
        this.spinner.show();

        //  KS_GUID: this.selectedFirm.KK , KK_Sahibi_GSM: string, Toplam_Tutar: string, firmId: any
        this.firmService.payment(paymentData, this.paymentMethod.value).subscribe(res => {
            this.spinner.hide();
            if (res.success) {
                Swal.fire('Ödeme Başarıyla Alındı', '', 'success');
            } else {
                Swal.fire('Ödeme Başarısız', res.err.message, 'error');
            }
        }, err => {
            this.spinner.hide();
            Swal.fire('Ödeme Başarısız', err.err.message, 'error');
        });
    }

    onPaymentMethodChange() {
        console.log(this.paymentMethod);
        if (!this.paymentMethod.status) {
            this.selectedFirm = {};
            this.paymentInfo = {};
            return [];
        }
        this.getFirmList(this.paymentMethod.value);
    }

    calculatePaymentPrice() {
       if (!this.selectedFirm || (this.selectedFirm && !this.selectedFirm._id)) {
            this.errorSwal.text = 'Seçili Firma Bulunamadı';
            this.errorSwal.show();
            return;
        }
        let total = 0;
        const autoamt = parseInt(this.paymentInfo.automatSize);
        const euro = parseFloat(this.paymentInfo.euro);
        const automatPrice = parseFloat(this.paymentInfo.automatPrice);

        total = automatPrice * euro;
        total = total * autoamt;
        this.paymentInfo['total'] = total.toFixed(2).replace('.', ',');

        Swal.fire({
            html: `<div> ${total.toFixed(2)} </div> Tutarında Ödeme Alınacaktır`,
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: 'Ödeme Al',
            cancelButtonText: `İptal`,
        }).then((result) => {
            if (result.value) {
                this.payment();
            }
        });

    }

}



// WEBPACK FOOTER //
// /home/escobar/Documents/Projects/E-VEND/Srl-Evend/FE/superadmin/src/app/firm-payment/firm-payment.component.ts